var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cloud",
    d: "M16.5917 49.9556C9.6375 49.9556 4 44.3181 4 37.3639C4 30.4097 9.6375 24.7722 16.5917 24.7722C18.0996 24.7722 19.5456 25.0372 20.8856 25.5233C23.5295 19.0564 29.8835 14.5 37.3018 14.5C47.0926 14.5 55.0296 22.437 55.0296 32.2278C55.0296 32.6591 55.0142 33.0868 54.9839 33.5104C57.9447 34.8737 60 37.8669 60 41.3402C60 46.0984 56.1428 49.9556 51.3846 49.9556H16.5917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/cloudy.0a41510669715e1c3405982123370256.svg";
export { ForwardRef as ReactComponent };